import { ArrowUpRight, Check } from "lucide-react";

export function PartnershipSection({ t }) {
    return (
        <section id="partnership" className="section partnership-section" data-testid="reset365-partnership-section">
            <div className="page-width partnership-section__inner">
                <div className="partnership-section__copy reveal"><p className="eyebrow eyebrow--light" data-testid="reset365-partnership-eyebrow">{t.eyebrow}</p><h2 data-testid="reset365-partnership-title">{t.title}</h2><p>{t.body}</p><a href="#soumission" className="button button--light" data-testid="reset365-partnership-cta">{t.cta}<ArrowUpRight size={16} aria-hidden="true" /></a></div>
                <ul className="partnership-list reveal">{t.items.map((item) => <li key={item}><Check size={17} aria-hidden="true" />{item}</li>)}</ul>
            </div>
        </section>
    );
}
